import { FC } from 'react';
import { Typography, Divider } from 'antd';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import FlexCol from '../../../../atoms/FlexCol';
import { PhoneCallRecord } from '#types';

const { Text, Paragraph } = Typography;

interface PhoneExpandedContentProps {
    record: PhoneCallRecord;
}

const PhoneExpandedContent: FC<PhoneExpandedContentProps> = ({ record }) => {
    const getDirectionDisplay = () => {
        if (!record.direction) return '—';
        
        const icon = record.direction === 'inbound' 
            ? <ArrowDownOutlined style={{ color: '#52c41a' }} />
            : <ArrowUpOutlined style={{ color: '#1890ff' }} />;
        
        const text = record.direction === 'inbound' ? 'Inbound' : 'Outbound';
        
        return <>{icon} {text}</>;
    };

    const getPhoneNumberDisplay = () => {
        if (!record.phoneNumber) return '—';
        
        if (record.phoneNumber.formatted) {
            return record.phoneNumber.formatted;
        }
        
        if (record.phoneNumber.components?.countryCode && record.phoneNumber.components?.number) {
            const { countryCode, number, extension } = record.phoneNumber.components;
            return `${countryCode} ${number}${extension ? ` ext. ${extension}` : ''}`;
        }
        
        return '—';
    };

    return (
        <FlexCol 
            style={{ 
                padding: 10,
                maxHeight: '50vh', 
                overflow: 'visible auto' 
            }}
            gap={0}
        >
            <Text>
                <Text strong>Direction: </Text>
                {getDirectionDisplay()}
            </Text>
            <Text>
                <Text strong>Phone Number: </Text>
                {getPhoneNumberDisplay()}
            </Text>
            <Text>
                <Text strong>Date: </Text>
                {record.timestamp ? dayjs(record.timestamp.toDate()).format('YYYY-MM-DD HH:mm') : '—'}
            </Text>
            {record.notes && (
                <FlexCol noGap>
                    <Divider style={{ margin: '10px 0' }} />
                    <Paragraph>
                        {record.notes}
                    </Paragraph>
                </FlexCol>
            )}
        </FlexCol>
    );
};

export default PhoneExpandedContent;

